import activities from './activities'
import create from './create'
import deleteTypes from './delete'
export default {
  ...activities,
  ...create,
  ...deleteTypes,
}
